export const GET_MENU_PRODUCTS = 'providers/menuMaker/MenuProducts/GET_MENU_PRODUCTS';
export const CHANGE_MENU_PRODUCT_PRICE = 'providers/menuMaker/MenuProducts/CHANGE_MENU_PRODUCT_PRICE';
